import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DisableOrganizationUserMutation } from "../graphql/mutations";
import type {
  DisableOrganizationUserMutationType,
  DisableOrganizationUserMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDisableOrganizationUserMutation = (
  options?: MutationHookOptions<
    DisableOrganizationUserMutationType,
    DisableOrganizationUserMutationVariablesType
  >
) => {
  return useMutation<
    DisableOrganizationUserMutationType,
    DisableOrganizationUserMutationVariablesType
  >(DisableOrganizationUserMutation, options);
};
